import urlUtils from '../utils/rbmc.url-utils.js';
import logger from '../utils/rbmc.logger';

const pdpBlacklist = {

    blacklist: undefined,

    fetchBlacklist() {
        if ($('#pdp__configuration-area').data('flock-enabled') === true) {
            let url     = urlUtils.getBaseUrl() + 'blacklist/';
            let request = $.ajax({
                url:    url,
                method: 'GET',
                cache:  true
            });
            request.done((response) => {
                pdpBlacklist.blacklist = response;
            });
            request.fail(function (x, e) {
                logger.debug('Cannot fetch blacklist from backend');
            });
        }
    },

    isBlacklisted(name) {
        return pdpBlacklist.blacklist !== undefined && $.inArray(name, pdpBlacklist.blacklist) > -1;
    }

};

export default pdpBlacklist;
